var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRestrictIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1.05vw",
    height: "1vw",
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.19671 15.3033C5.89316 15.9997 6.71996 16.5522 7.6299 16.9291C8.53985 17.306 9.51513 17.5 10.5 17.5C11.485 17.5 12.4602 17.306 13.3702 16.9291C14.2801 16.5522 15.1069 15.9997 15.8034 15.3033C16.4998 14.6068 17.0523 13.78 17.4292 12.8701C17.8061 11.9601 18.0001 10.9849 18.0001 9.99995C18.0001 9.01503 17.8061 8.03976 17.4292 7.12981C17.0523 6.21986 16.4998 5.39306 15.8034 4.69662M5.19671 15.3033C4.50027 14.6068 3.94782 13.78 3.57091 12.8701C3.19399 11.9601 3 10.9849 3 9.99995C3 9.01503 3.19399 8.03976 3.57091 7.12981C3.94782 6.21986 4.50027 5.39306 5.19671 4.69662C5.89316 4.00018 6.71996 3.44773 7.6299 3.07082C8.53985 2.6939 9.51513 2.49991 10.5 2.49991C11.485 2.49991 12.4602 2.6939 13.3702 3.07082C14.2801 3.44773 15.1069 4.00018 15.8034 4.69662M5.19671 15.3033L10.5 9.99995L15.8034 4.69662",
    stroke: "#BF3030",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestrictIcon);
export default __webpack_public_path__ + "static/media/restrictIcon.d33f41d23f95ad03bfd505ba92bc89e8.svg";
export { ForwardRef as ReactComponent };